//fields from profile to match ldap fields
const getType = (value) => {
    return Object.prototype.toString.call(value);
}
const isEmtpy = (value) => {
    if (value === null || value === undefined) {
        return true;
    }

    const type = getType(value);
    if (type === '[object Object') {
        return !(Object.keys(value).length);
    }
    if (type === '[object Array]') {
        return !value.length;
    }
    return !value;
}

const isSameAsUsername = (value, profile={}, fieldName) => {
    const nameValue = profile['name'];
    return value === nameValue && profile[fieldName] === nameValue;
}

const noDummyDotComEmail = (value='') => (/@dummy.com/.test(value));

const ldapFields = {
    "name": {
        displayLabelKey: "user-profile.fields.userName.label",
        validator: (value, profile) => {
            if (isEmtpy(value)) {
                return "user-profile.canNotBeEmpty";
            }
        },
        required: true,
    },
    "customerUID": {
        displayLabelKey: "user-profile.fields.customerUID.label",
        errorDisplayLabelKey: "user-profile.fields.customerUID.errorMsg"
    },
    "firstName": {
        displayLabelKey: "user-profile.fields.firstName.label",
        validator: (value, profile) => {
            return (isEmtpy(value) && "user-profile.canNotBeEmpty") || (isSameAsUsername(value, profile, 'lastName') && "user-profile.fields.firstName.errorMsg")
        },
        required: true,
    },
    "email": {
        displayLabelKey: "user-profile.fields.mail.label",
        validator: (value, profile) => {
            return (isEmtpy(value) && "user-profile.canNotBeEmpty") || (noDummyDotComEmail(value) && "user-profile.fields.mail.errorMsg")
        },
        required: true,
    },
    "lastName": {
        displayLabelKey: "user-profile.fields.familyName.label",
        validator: (value, profile) => {
            return (isEmtpy(value) && "user-profile.canNotBeEmpty") || (isSameAsUsername(value, profile, 'firstName') && "user-profile.fields.familyName.errorMsg")
        },
        required: true,
    },
    "middleName": {
        displayLabelKey: "user-profile.fields.middleName.label",
    },
    "officePhoneNumber": {
        displayLabelKey: "user-profile.fields.officePhoneNumber.label",
    },
    "homePhoneNumber": {
        displayLabelKey: "user-profile.fields.homePhoneNumber.label",
    },
    "mobilePhoneNumber": {
        displayLabelKey: "user-profile.fields.mobilePhoneNumber.label",
    },
    "language": {
        displayLabelKey: "user-profile.fields.language.label",
    },
    "zipCode": {
        displayLabelKey: "user-profile.fields.zipCode.label",
    },
    "location": {
        displayLabelKey: "user-profile.fields.location.label",
    },

}

export default ldapFields;


// WEBPACK FOOTER //
// ./src/app/containers/myProfile/ldapFields.js